import React, { useState, useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import { FaCookieBite, FaTimes } from 'react-icons/fa';

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <Container>
        <div className="cookie-content">
          <div className="cookie-icon">
            <FaCookieBite />
          </div>
          <div className="cookie-text">
            <h4>We value your privacy</h4>
            <p>
              We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
              By clicking "Accept All", you consent to our use of cookies.
            </p>
          </div>
          <div className="cookie-actions">
            <Button variant="outline-light" size="sm" onClick={handleDecline}>
              Decline
            </Button>
            <Button variant="primary" size="sm" onClick={handleAccept}>
              Accept All
            </Button>
          </div>
          <button className="cookie-close" onClick={handleDecline}>
            <FaTimes />
          </button>
        </div>
      </Container>
    </div>
  );
}

export default CookieConsent;
